<script>
import TextareaField from '@phoenix/mixins/components/form/fields/TextareaField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [TextareaField],

  setup(props) {
    return useField(props);
  },

  computed: {
    customFieldClasses() {
      if (this.isSgphx) {
        return ['sgphx-field--textarea', this.fieldClasses];
      }

      return ['field--textarea', this.fieldClasses];
    },
  },
};
</script>

<template>
  <textarea
    :id="fieldUniqueId"
    v-model="value"
    :name="field.name"
    :class="customFieldClasses"
    :aria-describedby="ariaDescribedby"
    :aria-label="field.ariaLabel"
    :placeholder="field.placeholder"
    :rows="field.rows || rows"
    :disabled="field.disabled"
  />
</template>
